require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2006-07-03-preparations.json") })
        }
      }, "path---articles-2006-07-03-preparations");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2006-07-03-preparations!./.cache/json/articles-2006-07-03-preparations.json
// module id = 477
// module chunks = 231608221292675